import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  signal
} from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Componente de pantalla de carga (splash screen) que se muestra al iniciar la aplicación.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-splash',
  imports: [CommonModule],
  template: `
    @if (canShow()) {
      <div
        class="flex h-screen z-50 justify-center items-center font-bold bg-indigo-50 bg-opacity-50"
      >
        <div
          class="w-[30rem] h-[30rem] flex flex-col justify-center items-center"
        >
          <h1 class="text-4xl font-extrabold mb-2 text-primary-500">
            Carga Masiva
          </h1>
          <img
            class="mb-2 w-[20rem] h-[20rem] rounded-full"
            src="assets/images/logoSura.gif"
            alt="splash"
          />
          <span
            class="animate-ping animate-duration-[1500ms] text-sm text-primary-200"
          >
            Cargando...</span
          >
        </div>
      </div>
    }
  `,
  styles: []
})
export class AppSplashComponent implements OnInit {
  /**
   * Indica si la pantalla de carga debe mostrarse o no.
   * @type {boolean}
   */
  protected canShow = signal(true);

  /**
   * Tiempo en milisegundos que la pantalla de carga se mostrará antes de ocultarse.
   * @type {number}
   */
  private timeToHide = 5000;

  ngOnInit() {
    setTimeout(() => {
      this.canShow.set(false);
    }, this.timeToHide);
  }
}
